export default class AgeGate {
	constructor(app) {
		this.app = app
		this.container = document.getElementById('agegate')
		this.inputs = this.container?.querySelectorAll('input')
		this.errorNotice = this.container?.querySelector('.age-gate__error')
		this.values = {
			year: '0000',
			day: '00',
			month: '00'
		}

		if (this.container) this._init()
	}

	_init() {
		if (ageGatePassed) this._onPassThrough()
		else {
			this.inputs.forEach((it, i) => {
				it.value = ''
				if (i === 0) it.focus()

				it.addEventListener('focus', () => {
					i === 0 ? this.inputs.forEach(el => el.value = '') : it.value = ''
				})

				it.addEventListener('input', () => {
					it.value = it.value.slice(0, it.maxLength)

					if (i < this.inputs.length - 1) {
						this.inputs[i + 1].value = ''
						this.inputs[i + 1].focus()
					} else {
						const aggregateValue = [ ...this.inputs ].reduce((acc, curr) => `${acc}${curr.value}`, '')
						const legal = new Date().getFullYear() - aggregateValue >= 18

						it.blur()

						if (aggregateValue.length < 4) return

						this.values.year = aggregateValue

						if (legal) setTimeout(() => this._onPass(), 100)
						else this._onTooYoung()
					}
				})
			})

			this.pushAnalytics('AgeGate_Shown')
		}
	}

	_onPass() {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
		document.body.classList.add('age-confirmed')

		const date = this.getFormattedDate()

		this.app.bus.emit('ageGatePassed')
		window.ageGatePassed = date
		window.cookies.setCookie('AGE_CONFIRMED', date, 30)
		this.pushAnalytics('AgeGate_Confirmed')
	}

	_onPassThrough() {
		document.body.classList.add('age-confirmed')
		this.container.remove()
		this.pushAnalytics('AgeGate_PassThrough')
	}

	_onTooYoung() {
		this.errorNotice.style.display = 'block'
		this.pushAnalytics('AgeGate_TooYoung')

		setTimeout(() => window.location.href = 'https://www.pijsrozumem.cz/', 2000)
	}

	getFormattedDate() {
		return this.values.year + '-00-00'
	}

	pushAnalytics(event, dob) {
		const data = { event }
		window.dataLayer.push(data)
	}
}
